import { useEffect, useRef, useState } from "react";
import { STILLS } from "@/stills";

export function useReveal() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setInView(true), { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return [ref, inView ? "reveal in" : "reveal"];
}

export function PhoneMock({ still, width = 260, spaStyle = "warm", animate = false }) {
  const def = STILLS[still];
  const inner = width - 24;
  const scale = inner / def.w;
  return (
    <div className="phone-mock" data-testid={`phone-mock-${still}`} data-animate={animate} style={{ width }}>
      <div style={{ width: inner, height: def.h * scale, overflow: "hidden", borderRadius: 34, background: "#fff" }}>
        <div style={{ width: def.w, height: def.h, transform: `scale(${scale})`, transformOrigin: "top left" }}>
          <def.Component spaStyle={spaStyle} animate={animate} />
        </div>
      </div>
    </div>
  );
}

export function TabletMock({ still, width = 420 }) {
  const def = STILLS[still];
  const inner = width - 28;
  const scale = inner / def.w;
  return (
    <div className="tablet-mock" data-testid={`tablet-mock-${still}`} style={{ width }}>
      <div style={{ width: inner, height: def.h * scale, overflow: "hidden", borderRadius: 16, background: "#fff" }}>
        <div style={{ width: def.w, height: def.h, transform: `scale(${scale})`, transformOrigin: "top left" }}>
          <def.Component />
        </div>
      </div>
    </div>
  );
}
